import {
  Avatar,
  Button,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Textarea,
  Chip,
} from "@nextui-org/react";

import React, { useEffect, useState } from "react";
import { AILogo } from "../../constant/FormBuilder/FormBuilderConstant";

const initalValidationError = {
  title: "",
  functionDefination: "",
};

const AddFormulaModal = ({
  onSubmitHandler,
  id,
  modalHeading,
  isOpen,
  onOpen,
  onOpenChange,
  fieldType,
}) => {
  const [title, setTitle] = useState("");
  const [functionDefintation, setFunctionDefination] = useState("");
  const [validationErrors, setValidationErrors] = useState({
    ...initalValidationError,
  });

  const validationHandler = () => {
    let isValid = true;
    const newValidationError = { ...initalValidationError };

    if (title === "") {
      newValidationError["title"] = "Title is required";
      isValid = false;
    }
    if (functionDefintation === "") {
      newValidationError["functionDefination"] =
        "Functiona defination is required";
      isValid = false;
    }

    setValidationErrors({ ...newValidationError });

    return isValid;
  };

  const submitHandler = (onClose) => {
    const isValid = validationHandler();
    if (isValid === false) return;

    onSubmitHandler({
      id: id,
      title: title,
      fun: functionDefintation,
    });
    onClose();
  };

  const handleKeyDown = (event, onClose) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent the default action of form submission on Enter key press
      submitHandler(onClose);
    }
  };

  useEffect(() => {
    setValidationErrors({ ...initalValidationError });

    if (isOpen) {
      setFunctionDefination(""); // Reset function definition only when the modal is opened
      setTitle(""); // Reset the title when the modal is opened
    }
  }, [isOpen]);

  return (
    <>
      <Modal 
        isOpen={isOpen} 
        onOpenChange={onOpenChange} 
        size="2xl"
        classNames={{
          base: "bg-white border border-slate-200 shadow-lg",
          header: "border-b border-slate-200 bg-slate-50",
          body: "py-6",
          footer: "border-t border-slate-200 bg-slate-50",
        }}
      >
        <ModalContent>
          {(onClose) => (
            <div className="outline-none">
              <ModalHeader className="flex flex-col gap-2 px-6 py-4">
                <div className="flex items-center justify-between w-full">
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900">Add a New Formula</h3>
                    <p className="text-sm text-slate-600 mt-1">Create a mathematical formula for your metric</p>
                  </div>
                  <Chip color="warning" variant="flat" size="sm">
                    Formula
                  </Chip>
                </div>
              </ModalHeader>
              <ModalBody className="px-6">
                <div className="space-y-6">
                  <Input
                    type="text"
                    className="mb-8"
                    isRequired
                    label={fieldType === "link" ? "Name" : "Title"}
                    placeholder=" "
                    variant="faded"
                    labelPlacement="outside"
                    value={title || ""}
                    onChange={(event) => {
                      setTitle(event.target.value);
                    }}
                    isInvalid={validationErrors["title"] !== ""}
                    errorMessage={validationErrors["title"]}
                    onKeyDown={(event) => handleKeyDown(event, onClose)}
                  />
                  <Textarea
                    className="my-4"
                    variant="faded"
                    isRequired
                    label={`Formula`}
                    labelPlacement="outside"
                    placeholder=" Describe the Formula that you want to be added."
                    onChange={(e) => setFunctionDefination(e.target.value)}
                    value={functionDefintation}
                    isInvalid={validationErrors["functionDefination"] !== ""}
                    errorMessage={validationErrors["functionDefination"]}
                  />
                  <div className="flex items-center gap-2">
                    <span>{AILogo}</span>
                    <span className="text-xs text-gray">
                      Powered by{" "}
                      <span className="font-semibold"> Audyt AI</span>
                    </span>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter className="px-6 py-4">
                <div className="flex gap-3 justify-end w-full">
                  <Button 
                    color="default" 
                    variant="bordered" 
                    onPress={onClose}
                    className="px-6 border-slate-300 hover:border-slate-400"
                  >
                    Cancel
                  </Button>
                  <Button 
                    color="primary" 
                    onClick={() => submitHandler(onClose)}
                    className="px-6 bg-emerald-600 hover:bg-emerald-700"
                  >
                    Add Formula
                  </Button>
                </div>
              </ModalFooter>
            </div>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddFormulaModal;
